export function wait(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}
export function buildDelayExecutor(func, delay) {
  return new ExecuteOnKeyEventHelper(func, delay)
}


class ExecuteOnKeyEventHelper {
  timeoutId
  delay
  func

  constructor(func, delay) {
    this.timeoutId = null
    this.delay = delay
    this.func = func
  }

  exec(...args) {
    if (this.timeoutId !== null) {
      clearTimeout(this.timeoutId)
      this.timeoutId = null
    }

    this.timeoutId = setTimeout(async () => {
      await this.func(...args)
      this.timeoutId = null
    }, this.delay)
  }
}